module.exports = __webpack_public_path__ + "assets/img/cbt_2025_thumb.b663caf5.png";